import { myAxios } from "../../../../utils/fetch";
import { useEffect, useState, useContext } from "react";
import { PrescriptionContextMemorySpace } from "../../../../contexts/orden-medica/prescriptionContext";
import { UserGlobalContextMemorySpace } from "../../../../contexts/user/userGlobalContext";

let text = "";

const usePagination = () => {
  const {
    setResults,
    results,
    loader,
    setLoader,
    resultsTemp,
    setResultsTemp,
    total,
    setTotal,
    offset,
    setOffset,
    limit,
    filteredResults,
    setFilteredResults,
    setSearchText,
  } = useContext(PrescriptionContextMemorySpace);
  const { user } = useContext(UserGlobalContextMemorySpace);
  const [selectedYear, setSelectedYear] = useState("Todos");

  const obtenerResultados = (idSap, filter) => {
    setResults([]);
    setLoader(true);

    const fechaDesde = "2017-01-01";
    const query = `patientId=${idSap}&fecha=${fechaDesde}`;
    const url = `/patient/api/v1/misalud/GetPatientOrdenClinicaDocumentsAll?${query}`;

    myAxios({
      url: process.env.REACT_APP_GATEWAY_2 + url,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
    })
      .then((response) => {
        setTotal(response.data.length);
        setLoader(false);
        var result = response.data.sort((a, b) => new Date(b.fechA_PREF) - new Date(a.fechA_PREF));
        setResults(result);
      })
      .catch((error) => {
        setResults([]);
        setLoader(false);
      })
      .finally(() => {
        setLoader(false);
        setOffset(0);
      });
  };

  useEffect(() => {
    setTotal(results?.length);
    setResultsTemp(results?.slice(0, limit));
  }, [results]);

  useEffect(() => {
    if (text) {
      setResultsTemp(filteredResults?.slice(offset, offset + limit));
      return;
    }
    setResultsTemp(results?.slice(offset, offset + limit));
  }, [offset]);

  const siguiente = () => {
    if (offset + limit < total) {
      setOffset(offset + limit);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const anterior = () => {
    const temporalOffset = offset - limit;
    if (temporalOffset >= 0) {
      setOffset(temporalOffset);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const searchData = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchText(event.target.value);
    text = searchValue;

    applyFilters(searchValue, selectedYear); // <-- Usa el año seleccionado actual
  };

  const applyFilters = (searchTextValue = "", yearValue = "Todos") => {
    let filtered = [...results];

    if (yearValue !== "Todos") {
      filtered = filtered.filter((item) => {
        const itemYear = item.fechA_PREF?.substring(0, 4);
        return itemYear === yearValue.toString();
      });
    }

    if (searchTextValue) {
      filtered = filtered.filter((item) => {
        const matchDiagnostico = item.diagnostico?.toLowerCase().includes(searchTextValue);

        const matchPrestaciones = item.prestaciones?.some((prest) =>
          prest.toLowerCase().includes(searchTextValue)
        );

        return matchDiagnostico || matchPrestaciones;
      });
    }

    setFilteredResults(filtered);
    setResultsTemp(filtered.slice(0, limit));
    setTotal(filtered.length);
    setOffset(0);
    setSelectedYear(yearValue); // <-- Actualizamos el año seleccionado
  };

  return {
    results,
    resultsTemp,
    loader,
    total,
    offset,
    limit,
    siguiente,
    anterior,
    obtenerResultados,
    searchData,
    applyFilters
  };
};

export default usePagination;
